type NodeContainer = {
  value: string;
  index: number;
};

export class ENode {
  node: NodeContainer;
  left: ENode | null;
  right: ENode | null;
  constructor(
    value: NodeContainer,
    left: ENode | null = null,
    right: ENode | null = null
  ) {
    this.node = value;
    this.left = left;
    this.right = right;
  }
}

export class Parser {
  original_expression: string | string[];
  tokens: string[];
  index: number;

  constructor(expression: string | string[]) {
    this.original_expression = expression;
    if (Array.isArray(expression)) {
      this.tokens = expression;
    } else {
      // add single space around parenthesis
      expression = expression.replace(/\(/g, " ( ");
      expression = expression.replace(/\)/g, " ) ");
      expression = expression.replace(/\s+/g, " ");

      this.tokens = expression.split(" ").filter((x) => x.length > 0);
    }
    this.index = 0;
  }

  parse() {
    return this.parseExpression();
  }

  parseExpression(): ENode {
    let left = this.parseTerm();

    while (this.tokens[this.index] === "or") {
      let op = { value: this.tokens[this.index], index: this.index };
      this.index++;
      let right = this.parseTerm();
      left = new ENode(op, left, right);
    }

    return left;
  }

  parseTerm(): ENode {
    let left = this.parseFactor();

    while (this.tokens[this.index] === "and") {
      let op = { value: this.tokens[this.index], index: this.index };
      this.index++;
      let right = this.parseFactor();
      left = new ENode(op, left, right);
    }

    return left;
  }

  parseFactor(): ENode {
    if (this.tokens[this.index] === "(") {
      this.index++;
      let node = this.parseExpression();
      if (this.tokens[this.index] !== ")") {
        throw new Error("Expected )");
      }
      this.index++;
      return node;
    }
    let value = this.tokens[this.index];
    const newnode = new ENode({ value, index: this.index });
    this.index++;
    return newnode;
  }
}
